import { FC } from 'react'
import { useTranslate } from 'react-polyglot'
import { Grid } from '@material-ui/core'

import { ManagedAccountsByPartner } from 'hooks/useManagedAccounts'
import { Account } from 'types/Account'
import { useStyles } from './AccountMenuForPartners'
import Section from './Section'

interface SinglePartnerProps {
  accounts: Account[]
  managedAccountsByPartner: ManagedAccountsByPartner
  onSelectAccount: (account: Account) => void
}

const SinglePartner: FC<SinglePartnerProps> = ({ accounts, managedAccountsByPartner, onSelectAccount, ...props }) => {
  const t = useTranslate()
  const classes = useStyles()

  return (
    <Grid data-testid="single-partner" className={classes.accountListFilterHolder} item xs {...props}>
      {!!accounts.length && (
        <Section
          data-testid="my-accounts-section"
          title={t('My Accounts')}
          accounts={accounts}
          onClick={onSelectAccount}
        />
      )}
      <Section
        title={managedAccountsByPartner.partnerAccount.name}
        accounts={managedAccountsByPartner.customerAccounts}
        onClick={onSelectAccount}
      />
    </Grid>
  )
}

export default SinglePartner
